module.exports = __webpack_public_path__ + "pc/static/img/wechat.45dc21eb.png";